var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuideIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "guide-icon-2_svg__a",
    d: "M0 40h40.355V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.788 15.919c0 8.791 7.127 15.918 15.919 15.918 8.791 0 15.918-7.127 15.918-15.918C34.625 7.127 27.498 0 18.707 0 9.915 0 2.788 7.127 2.788 15.92",
    fill: "#F8D7CC"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "guide-icon-2_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#guide-icon-2_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#guide-icon-2_svg__b)",
    d: "M6.609 21.535h3.82v-8.278h-3.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.245 20.898h2.547v-7.004H7.245v7.004zm-1.273 1.274h5.094V12.62H5.972v9.55z",
    fill: "#020303",
    mask: "url(#guide-icon-2_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#guide-icon-2_svg__b)",
    d: "M30.168 39.364H4.698V22.172l12.735-10.188 12.735 10.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E9EA",
    mask: "url(#guide-icon-2_svg__b)",
    d: "M17.433 16.441l4.474 3.501 3.243-1.725-7.717-6.233L.878 25.355l1.91 2.547z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.804 40H4.062V26.205a.636.636 0 111.273 0v12.522h24.196v-3.184a.636.636 0 111.273 0V40z",
    fill: "#020303",
    mask: "url(#guide-icon-2_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.669 28.804L0 25.246l17.433-14.08 8.117 6.555a.637.637 0 01-.8.991l-7.317-5.91L1.756 25.465 2.908 27l14.525-11.368 4.866 3.81a.636.636 0 11-.784 1.001l-4.082-3.193L2.669 28.804z",
    fill: "#020303",
    mask: "url(#guide-icon-2_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.262 26.31a6.686 6.686 0 11-13.372 0 6.686 6.686 0 0113.372 0",
    fill: "#FEFEFE",
    mask: "url(#guide-icon-2_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.576 20.261a6.056 6.056 0 00-6.05 6.05 6.056 6.056 0 006.05 6.048 6.056 6.056 0 006.049-6.049 6.056 6.056 0 00-6.05-6.049m0 13.372c-4.037 0-7.322-3.285-7.322-7.323 0-4.037 3.285-7.322 7.323-7.322 4.037 0 7.322 3.285 7.322 7.322 0 4.038-3.285 7.323-7.322 7.323",
    fill: "#020303",
    mask: "url(#guide-icon-2_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.501 26.224a.637.637 0 01-.628-.747 4.755 4.755 0 013.654-3.826.636.636 0 11.279 1.243 3.486 3.486 0 00-2.678 2.804.637.637 0 01-.627.526m15.218 11.229a.635.635 0 01-.45-.186l-6.11-6.11a.637.637 0 01.9-.9l6.11 6.11a.636.636 0 01-.45 1.086",
    fill: "#020303",
    mask: "url(#guide-icon-2_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74A10",
    mask: "url(#guide-icon-2_svg__b)",
    d: "M11.066 39.363h5.094V30.45h-5.094z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.702 38.727h3.82v-7.641h-3.82v7.64zM10.43 40h6.367V29.812H10.43V40z",
    fill: "#020303",
    mask: "url(#guide-icon-2_svg__b)"
  }))));
}
export default SvgGuideIcon2;